var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,10.7v-0.33C2,6.3,5.28,3,9.33,3h5.33C18.72,3,22,6.3,22,10.37c0,4.05-3.25,7.34-7.28,7.37l-3.31,2.78 C10.06,21.65,8,20.68,8,18.91v-1.24C4.61,17.18,2,14.25,2,10.7z M10.13,18.97l3.56-2.98c0.2-0.17,0.45-0.26,0.72-0.26h0.26 c2.95,0,5.33-2.4,5.33-5.36c0-2.96-2.39-5.36-5.33-5.36H9.33C6.39,5.01,4,7.41,4,10.37v0.33c0,2.77,2.24,5.02,5,5.02 c0.47,0,0.86,0.32,0.97,0.76C9.99,16.56,10,16.65,10,16.73v2.17C10,18.97,10.08,19.01,10.13,18.97z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chat_bubble.e05266636bcf2f8afdb22e6eadde9ed8.svg";
export { ForwardRef as ReactComponent };